import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../../dispatcher/AdminAppDispatcher';
import AdminConstants from '../../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'CREATE_QUOTE_CHANGED';

let quote = null;

let state = {
  pending: false,
  complete: false,
  success: false,
  fail: false,
  error: '',
};

const CreateQuoteStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  getRequestState() {
    return state;
  },

  getQuote() {
    return quote;
  },

  onCreateQuoteRequest() {
    state = {
      ...state,
      pending: true,
      complete: false,
      success: false,
      fail: false,
    };

    this.emitChange();
  },

  onCreateQuoteSuccess(newQuote) {
    quote = { ...newQuote };

    state = {
      ...state,
      pending: false,
      complete: true,
      success: true,
      fail: false,
    };

    this.emitChange();
  },

  onCreateQuoteFail(error) {
    state = {
      ...state,
      pending: false,
      complete: true,
      success: false,
      fail: true,
      error,
    };

    this.emitChange();
  },
  onUpdateQuoteRequest() {
    state = {
      ...state,
      pending: true,
      complete: false,
      success: false,
      fail: false,
    };

    this.emitChange();
  },

  onUpdateQuoteSuccess(newQuote) {
    quote = { ...newQuote };

    state = {
      ...state,
      pending: false,
      complete: true,
      success: true,
      fail: false,
    };

    this.emitChange();
  },

  onUpdateQuoteFail(error) {
    state = {
      ...state,
      pending: false,
      complete: true,
      success: false,
      fail: true,
      error,
    };

    this.emitChange();
  },
});

CreateQuoteStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
  const action = payload.action;
  switch (action.type) {
    case ActionTypes.CREATE_QUOTE_SUCCESS:
      CreateQuoteStore.onCreateQuoteSuccess(action.quote);
      break;
    case ActionTypes.CREATE_QUOTE_FAIL:
      CreateQuoteStore.onCreateQuoteFail(action.error);
      break;
    case ActionTypes.CREATE_QUOTE_REQUEST:
      CreateQuoteStore.onCreateQuoteRequest();
      break;
    case ActionTypes.UPDATE_QUOTE_REQUEST:
      CreateQuoteStore.onUpdateQuoteRequest();
      break;
    case ActionTypes.UPDATE_QUOTE_SUCCESS:
      CreateQuoteStore.onUpdateQuoteSuccess(action.quote);
      break;
    case ActionTypes.UPDATE_QUOTE_FAIL:
      CreateQuoteStore.onUpdateQuoteFail(action.error);
      break;
    default:
      break;
  }
});

export default CreateQuoteStore;
